export const APP_VERSION = 'v3.1.0';
export const BUILD_DATE = '2026-03-27';
